import React, { useEffect, useState, createElement, Component } from 'react';
import { ArrowRight, Check, X, Shield, Heart, MessageCircle, Clock, AlertTriangle, Lock, Star, RefreshCw, ChevronDown } from 'lucide-react';
// --- Modal Component ---
function LegalModal({
  open,
  onClose,
  type
}: {
  open: boolean;
  onClose: () => void;
  type: 'privacy' | 'terms';
}) {
  if (!open) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={onClose} data-id="element-2">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-3" />
      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-4">
        {/* Header */}
        <div className="bg-[#1a2744] px-6 py-4 flex items-center justify-between flex-shrink-0" data-id="element-5">
          <div className="flex items-center gap-2" data-id="element-6">
            <Shield className="w-5 h-5 text-[#f59e0b]" data-id="element-7" />
            <h2 className="text-white font-bold text-lg" data-id="element-8">
              {type === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
            </h2>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors p-1 rounded-full hover:bg-white/10" data-id="element-9">
            <X className="w-5 h-5" data-id="element-10" />
          </button>
        </div>

        {/* Scrollable content */}
        <div className="overflow-y-auto px-6 py-6 text-sm text-gray-700 leading-relaxed space-y-5" data-id="element-11">
          {type === 'privacy' ? <>
              <p className="text-xs text-gray-400" data-id="element-12">
                Última actualización: Febrero 2026
              </p>

              <div data-id="element-13">
                <h3 className="font-bold text-[#1a2744] mb-1" data-id="element-14">
                  1. Información que recopilamos
                </h3>
                <p data-id="element-15">
                  Al realizar una compra en este sitio, recopilamos únicamente
                  la información necesaria para procesar tu pedido y entregarte
                  el producto digital: nombre, dirección de correo electrónico y
                  datos de pago (procesados de forma segura por nuestro
                  proveedor de pagos). No almacenamos datos de tarjetas de
                  crédito en nuestros servidores.
                </p>
              </div>

              <div data-id="element-16">
                <h3 className="font-bold text-[#1a2744] mb-1" data-id="element-17">
                  2. Cómo usamos tu información
                </h3>
                <p data-id="element-18">Usamos tu información exclusivamente para:</p>
                <ul className="list-disc pl-5 mt-1 space-y-1" data-id="element-19">
                  <li data-id="element-20">
                    Enviarte el acceso al producto digital adquirido (Protocolo
                    Vínculo Blindado).
                  </li>
                  <li data-id="element-21">
                    Gestionar tu garantía de 30 días y solicitudes de reembolso.
                  </li>
                  <li data-id="element-22">Enviarte comunicaciones relacionadas con tu compra.</li>
                  <li data-id="element-23">
                    Mejorar nuestros productos y servicios de forma anónima y
                    agregada.
                  </li>
                </ul>
              </div>

              <div data-id="element-24">
                <h3 className="font-bold text-[#1a2744] mb-1" data-id="element-25">
                  3. Producto digital y entrega
                </h3>
                <p data-id="element-26">
                  Vínculo Blindado es un producto de información digital (PDF y
                  materiales descargables). Tras la compra, recibirás un correo
                  electrónico con las instrucciones de acceso. Es tu
                  responsabilidad proporcionar una dirección de correo válida.
                </p>
              </div>

              <div data-id="element-27">
                <h3 className="font-bold text-[#1a2744] mb-1" data-id="element-28">
                  4. Cookies y tecnologías de seguimiento
                </h3>
                <p data-id="element-29">
                  Este sitio puede utilizar cookies de sesión y píxeles de
                  seguimiento (incluyendo Meta Pixel) con fines de análisis y
                  publicidad. Puedes desactivar las cookies desde la
                  configuración de tu navegador, aunque esto puede afectar la
                  funcionalidad del sitio.
                </p>
              </div>

              <div data-id="element-30">
                <h3 className="font-bold text-[#1a2744] mb-1" data-id="element-31">
                  5. Compartir información con terceros
                </h3>
                <p data-id="element-32">
                  No vendemos, alquilamos ni compartimos tu información personal
                  con terceros, excepto con proveedores de servicios esenciales
                  (procesadores de pago, plataformas de entrega de email) que
                  están contractualmente obligados a proteger tu información y
                  usarla únicamente para prestarnos sus servicios.
                </p>
              </div>

              <div data-id="element-33">
                <h3 className="font-bold text-[#1a2744] mb-1" data-id="element-34">
                  6. Seguridad de los datos
                </h3>
                <p data-id="element-35">
                  Implementamos medidas de seguridad estándar de la industria
                  para proteger tu información. Las transacciones de pago se
                  realizan a través de conexiones SSL cifradas.
                </p>
              </div>

              <div data-id="element-36">
                <h3 className="font-bold text-[#1a2744] mb-1" data-id="element-37">
                  7. Tus derechos
                </h3>
                <p data-id="element-38">
                  Tienes derecho a acceder, corregir o solicitar la eliminación
                  de tu información personal. Para ejercer estos derechos,
                  puedes comunicarte con nosotros a través de los canales de
                  soporte indicados en tu correo de confirmación de compra.
                </p>
              </div>

              <div data-id="element-39">
                <h3 className="font-bold text-[#1a2744] mb-1" data-id="element-40">
                  8. Menores de edad
                </h3>
                <p data-id="element-41">
                  Este producto está dirigido a padres y adultos mayores de 18
                  años. No recopilamos conscientemente información de menores de
                  edad.
                </p>
              </div>

              <div data-id="element-42">
                <h3 className="font-bold text-[#1a2744] mb-1" data-id="element-43">
                  9. Cambios a esta política
                </h3>
                <p data-id="element-44">
                  Podemos actualizar esta política ocasionalmente. Los cambios
                  serán publicados en esta página con la fecha de actualización
                  correspondiente.
                </p>
              </div>
            </> : <>
              <p className="text-xs text-gray-400" data-id="element-45">
                Última actualización: Febrero 2026
              </p>

              <div data-id="element-46">
                <h3 className="font-bold text-[#1a2744] mb-1" data-id="element-47">
                  1. Aceptación de los términos
                </h3>
                <p data-id="element-48">
                  Al adquirir el Protocolo Vínculo Blindado, aceptas plenamente
                  estos Términos y Condiciones. Si no estás de acuerdo con
                  alguno de ellos, te pedimos que no realices la compra.
                </p>
              </div>

              <div data-id="element-49">
                <h3 className="font-bold text-[#1a2744] mb-1" data-id="element-50">
                  2. Descripción del producto
                </h3>
                <p data-id="element-51">
                  Vínculo Blindado es un producto de información digital que
                  incluye:
                </p>
                <ul className="list-disc pl-5 mt-1 space-y-1" data-id="element-52">
                  <li data-id="element-53">El Protocolo Central de 21 Días (PDF).</li>
                  <li data-id="element-54">
                    Scripts de Micro-Mensajes Estratégicos listos para usar.
                  </li>
                  <li data-id="element-55">
                    Guía de Crisis para situaciones de alta tensión familiar.
                  </li>
                </ul>
                <p className="mt-2" data-id="element-56">
                  El producto está diseñado como una guía de orientación para
                  padres. No constituye asesoramiento psicológico, terapéutico
                  ni médico profesional.
                </p>
              </div>

              <div data-id="element-57">
                <h3 className="font-bold text-[#1a2744] mb-1" data-id="element-58">
                  3. Uso personal y licencia
                </h3>
                <p data-id="element-59">
                  Al comprar este producto, adquieres una licencia personal, no
                  exclusiva e intransferible para uso propio. Queda
                  estrictamente prohibido:
                </p>
                <ul className="list-disc pl-5 mt-1 space-y-1" data-id="element-60">
                  <li data-id="element-61">
                    Reproducir, distribuir o revender el contenido total o
                    parcialmente.
                  </li>
                  <li data-id="element-62">Compartir el acceso o los archivos con terceros.</li>
                  <li data-id="element-63">
                    Utilizar el contenido con fines comerciales sin autorización
                    expresa.
                  </li>
                </ul>
              </div>

              <div data-id="element-64">
                <h3 className="font-bold text-[#1a2744] mb-1" data-id="element-65">
                  4. Garantía de satisfacción de 30 días
                </h3>
                <p data-id="element-66">
                  Ofrecemos una garantía de devolución de dinero de 30 días a
                  partir de la fecha de compra. Si aplicas el protocolo de buena
                  fe y no observas ningún cambio positivo en la dinámica con tu
                  hijo/a, puedes solicitar un reembolso completo sin necesidad
                  de justificación. El reembolso se procesará en un plazo de 5 a
                  10 días hábiles.
                </p>
              </div>

              <div data-id="element-67">
                <h3 className="font-bold text-[#1a2744] mb-1" data-id="element-68">
                  5. Resultados y descargo de responsabilidad
                </h3>
                <p data-id="element-69">
                  Los testimonios y resultados mencionados en este sitio son
                  experiencias individuales y no garantizan resultados idénticos
                  para todos los usuarios. Los resultados dependen de múltiples
                  factores individuales, incluyendo la consistencia en la
                  aplicación del protocolo, la situación familiar específica y
                  las características del adolescente. Este producto es una guía
                  complementaria y no reemplaza la atención de un profesional de
                  salud mental cuando sea necesario.
                </p>
              </div>

              <div data-id="element-70">
                <h3 className="font-bold text-[#1a2744] mb-1" data-id="element-71">
                  6. Precio y pago
                </h3>
                <p data-id="element-72">
                  El precio del producto es de $6.39 USD (precio de lanzamiento,
                  sujeto a cambios). El pago se procesa de forma segura a través
                  de nuestro proveedor de pagos. Todos los precios están
                  expresados en dólares estadounidenses (USD).
                </p>
              </div>

              <div data-id="element-73">
                <h3 className="font-bold text-[#1a2744] mb-1" data-id="element-74">
                  7. Entrega del producto
                </h3>
                <p data-id="element-75">
                  Tras la confirmación del pago, recibirás un correo electrónico
                  con el enlace de descarga o acceso al producto en un plazo
                  máximo de 24 horas. Si no recibes el correo, revisa tu carpeta
                  de spam o solicita asistencia a través de los canales de
                  soporte.
                </p>
              </div>

              <div data-id="element-76">
                <h3 className="font-bold text-[#1a2744] mb-1" data-id="element-77">
                  8. Propiedad intelectual
                </h3>
                <p data-id="element-78">
                  Todo el contenido de Vínculo Blindado, incluyendo textos,
                  metodología, scripts y materiales, está protegido por derechos
                  de autor. Queda prohibida su reproducción total o parcial sin
                  autorización escrita.
                </p>
              </div>

              <div data-id="element-79">
                <h3 className="font-bold text-[#1a2744] mb-1" data-id="element-80">
                  9. Modificaciones
                </h3>
                <p data-id="element-81">
                  Nos reservamos el derecho de modificar estos términos en
                  cualquier momento. Las compras realizadas antes de cualquier
                  modificación se regirán por los términos vigentes en el
                  momento de la transacción.
                </p>
              </div>

              <div data-id="element-82">
                <h3 className="font-bold text-[#1a2744] mb-1" data-id="element-83">
                  10. Ley aplicable
                </h3>
                <p data-id="element-84">
                  Estos términos se rigen por las leyes aplicables al comercio
                  electrónico internacional. Cualquier disputa será resuelta de
                  buena fe entre las partes.
                </p>
              </div>
            </>}
        </div>

        {/* Footer */}
        <div className="border-t border-gray-100 px-6 py-4 flex-shrink-0 bg-gray-50" data-id="element-85">
          <button onClick={onClose} className="w-full bg-[#1a2744] hover:bg-[#243460] text-white font-bold py-2.5 rounded-lg transition-colors text-sm" data-id="element-86">
            Entendido, cerrar
          </button>
        </div>
      </div>
    </div>;
}
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}
export function SalesPage() {
  const [modal, setModal] = useState<'privacy' | 'terms' | null>(null);
  // Inject Meta Pixel and fire PageView on mount
  useEffect(() => {
    // Inject pixel script
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1957605735179882');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Noscript fallback
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1957605735179882&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
  }, []);
  const handleAddToCart = () => {
    // Fire AddToCart event
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Protocolo Vínculo Blindado',
        content_ids: ['51416018977089'],
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
    // Redirect after 150ms to allow pixel to fire
    setTimeout(() => {
      window.location.href = 'https://www.elmetodomoderno.com/cart/51416018977089:1';
    }, 150);
  };
  const scrollToOffer = () => {
    const element = document.getElementById('offer');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen w-full bg-[#fdf8f0] text-[#1f2937]" data-id="element-87">
      {/* Legal Modals */}
      <LegalModal open={modal === 'privacy'} onClose={() => setModal(null)} type="privacy" data-id="element-88" />
      <LegalModal open={modal === 'terms'} onClose={() => setModal(null)} type="terms" data-id="element-89" />

      {/* Sticky Header */}
      <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-sm border-b border-gray-100 shadow-sm py-3 px-4 md:px-6" data-id="element-90">
        <div className="max-w-6xl mx-auto flex justify-between items-center" data-id="element-91">
          <div className="flex items-center gap-2" data-id="element-92">
            <Shield className="w-6 h-6 text-[#1a2744]" data-id="element-93" />
            <span className="font-serif font-bold text-[#1a2744] text-lg md:text-xl tracking-tight" data-id="element-94">
              Vínculo Blindado
            </span>
          </div>
          <button onClick={scrollToOffer} className="bg-[#f59e0b] hover:bg-[#d97706] text-white font-medium py-2 px-4 rounded-full text-sm transition-colors shadow-md flex items-center gap-1" data-id="element-95">
            Quiero el Protocolo <ArrowRight className="w-4 h-4" data-id="element-96" />
          </button>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative bg-[#1a2744] text-white pt-12 pb-20 px-4 md:px-6 overflow-hidden" data-id="element-97">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-98">
          <div className="absolute top-[-10%] right-[-5%] w-96 h-96 rounded-full bg-[#f59e0b] blur-[100px]" data-id="element-99"></div>
          <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 rounded-full bg-[#dc2626] blur-[100px]" data-id="element-100"></div>
        </div>

        <div className="max-w-6xl mx-auto relative z-10" data-id="element-101">
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-102">
            {/* Hero Content */}
            <div className="flex-1 text-center md:text-left" data-id="element-103">
              <div className="inline-block bg-[#f59e0b]/20 border border-[#f59e0b]/30 rounded-full px-4 py-1 mb-6" data-id="element-104">
                <span className="text-[#f59e0b] font-bold text-xs md:text-sm tracking-wide uppercase" data-id="element-105">
                  Protocolo de 21 Días
                </span>
              </div>

              <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-6 text-white" data-id="element-106">
                Dejó de hablarme y empezó a encerrarse:{' '}
                <span className="text-[#f59e0b]" data-id="element-107">Cómo recuperé a mi hijo</span>{' '}
                sin un solo grito.
              </h1>

              <p className="text-lg md:text-xl text-gray-300 mb-8 leading-relaxed max-w-2xl mx-auto md:mx-0" data-id="element-108">
                El método basado en{' '}
                <span className="text-white font-semibold" data-id="element-109">
                  Micro-Mensajes Estratégicos
                </span>{' '}
                que rompe el muro de silencio — sin confrontación, sin dramas.
              </p>

              <div className="flex flex-col sm:flex-row items-center gap-4 mb-6 justify-center md:justify-start" data-id="element-110">
                <button onClick={handleAddToCart} className="w-full sm:w-auto bg-[#f59e0b] hover:bg-[#d97706] text-white text-lg font-bold py-4 px-8 rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2" data-id="element-111">
                  SÍ, QUIERO RECUPERAR A MI HIJO{' '}
                  <ArrowRight className="w-5 h-5" data-id="element-112" />
                </button>
              </div>

              <div className="flex flex-wrap justify-center md:justify-start gap-4 text-sm font-medium text-gray-300" data-id="element-113">
                <div className="flex items-center gap-1.5" data-id="element-114">
                  <Check className="w-4 h-4 text-[#f59e0b]" data-id="element-115" />
                  <span data-id="element-116">Sin confrontación</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-117">
                  <Check className="w-4 h-4 text-[#f59e0b]" data-id="element-118" />
                  <span data-id="element-119">Resultados en 7 días</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-120">
                  <Check className="w-4 h-4 text-[#f59e0b]" data-id="element-121" />
                  <span data-id="element-122">Plan paso a paso</span>
                </div>
              </div>
            </div>

            {/* Hero Image */}
            <div className="flex-1 w-full max-w-md md:max-w-full relative" data-id="element-123">
              <div className="relative z-10 transform md:rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-124">
                <img src="https://cdn.magicpatterns.com/uploads/a14AAANKeUpFqUFkhjmY1X/heylloyd-image-1771909290386.png" alt="Protocolo Vínculo Blindado en Tablet" className="w-full h-auto drop-shadow-2xl rounded-xl border border-white/10" data-id="element-125" />
              </div>
              {/* Decorative elements behind image */}
              <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#f59e0b] rounded-full opacity-20 blur-xl" data-id="element-126"></div>
              <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-[#1a2744] rounded-full opacity-40 blur-xl" data-id="element-127"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Pain/Empathy Section */}
      <section className="py-20 px-4 md:px-6 bg-[#fdf8f0]" data-id="element-128">
        <div className="max-w-3xl mx-auto" data-id="element-129">
          <div className="text-center mb-12" data-id="element-130">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1a2744] mb-4" data-id="element-131">
              ¿Te suena familiar?
            </h2>
            <div className="w-24 h-1 bg-[#dc2626] mx-auto rounded-full" data-id="element-132"></div>
          </div>

          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-orange-100 mb-10" data-id="element-133">
            <p className="font-serif italic text-xl text-[#1f2937] leading-relaxed mb-8 border-l-4 border-[#f59e0b] pl-6" data-id="element-134">
              "¿Recuerdas cuando tu hijo corría hacia ti al llegar a casa?
              Cuando eras la persona a la que acudía para todo."
            </p>

            <div className="space-y-5" data-id="element-135">
              {['Hoy responde con monosílabos y vive detrás de una puerta cerrada.', 'Sientes que caminas sobre cáscaras de huevo en tu propia casa.', 'Tienes miedo de preguntar algo y provocar una explosión.', 'Ves cómo su teléfono se convierte en su único refugio.', 'Lo que más te aterra: si no haces algo ahora, podrías perderlo para siempre.'].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-136">
                  <div className="mt-1 min-w-6 min-h-6 flex items-center justify-center bg-red-100 rounded-full" data-id="element-137">
                    <X className="w-4 h-4 text-[#dc2626]" data-id="element-138" />
                  </div>
                  <p className="text-gray-700 text-lg" data-id="element-139">{item}</p>
                </div>)}
            </div>
          </div>

          <p className="text-center text-xl font-medium text-[#1a2744] max-w-2xl mx-auto" data-id="element-140">
            Esa persona que sientes que estás perdiendo...{' '}
            <span className="text-[#dc2626] font-bold underline decoration-wavy decoration-[#dc2626]/30" data-id="element-141">
              todavía está ahí
            </span>
            . Solo necesita que llegues a ella de la manera correcta.
          </p>
        </div>
      </section>

      {/* Reframe Section */}
      <section className="py-20 px-4 md:px-6 bg-[#1a2744] text-white relative overflow-hidden" data-id="element-142">
        <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-143">
          <span className="inline-block py-1 px-3 rounded bg-[#dc2626] text-white text-xs font-bold tracking-widest uppercase mb-6" data-id="element-144">
            El Problema Real
          </span>

          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-145">
            No es rebeldía. <br data-id="element-146" />
            <span className="text-[#f59e0b]" data-id="element-147">Es desconexión.</span>
          </h2>

          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 md:p-12 text-left mb-8" data-id="element-148">
            <p className="text-lg md:text-xl text-gray-200 leading-relaxed mb-6" data-id="element-149">
              La mayoría de los padres intentan solucionar la distancia con más
              control:{' '}
              <span className="text-white font-semibold" data-id="element-150">
                más reglas, más gritos, quitar el teléfono.
              </span>
            </p>
            <p className="text-lg md:text-xl text-gray-200 leading-relaxed mb-6" data-id="element-151">
              Pero en el cerebro adolescente de hoy, eso solo activa el modo de
              supervivencia. Ellos no te escuchan porque su cerebro ha
              clasificado tu voz como{' '}
              <span className="text-[#f59e0b] font-bold" data-id="element-152">
                "ruido de amenaza"
              </span>
              .
            </p>
            <p className="text-lg md:text-xl text-gray-200 leading-relaxed" data-id="element-153">
              Para recuperarlos, no necesitas gritar más fuerte. Necesitas
              cambiar la frecuencia en la que transmites.
            </p>
          </div>

          {/* Amber callout box */}
          <div className="bg-[#f59e0b] rounded-2xl p-6 md:p-8 text-left" data-id="element-154">
            <p className="text-[#1a2744] text-lg md:text-xl font-bold font-serif leading-relaxed" data-id="element-155">
              "Mientras más presionas, más se aleja. No porque no te ame. Sino
              porque su cerebro adolescente está en modo defensa."
            </p>
          </div>

          <p className="mt-8 text-gray-300 text-lg" data-id="element-156">
            Existe una forma diferente. Una que funciona{' '}
            <span className="text-white font-bold underline decoration-[#f59e0b]" data-id="element-157">
              CON su cerebro
            </span>
            , no contra él.
          </p>
        </div>
      </section>

      {/* Solution Introduction */}
      <section className="py-20 px-4 md:px-6 bg-white" data-id="element-158">
        <div className="max-w-5xl mx-auto" data-id="element-159">
          <div className="text-center mb-16" data-id="element-160">
            <p className="text-[#f59e0b] font-bold tracking-wider uppercase mb-2" data-id="element-161">
              Presentando
            </p>
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#1a2744] mb-6" data-id="element-162">
              Protocolo Vínculo Blindado
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-163">
              No es un libro de psicología aburrido. Es un{' '}
              <span className="font-bold text-[#1a2744]" data-id="element-164">
                plan de acción de 21 días
              </span>{' '}
              basado en la técnica de Micro-Mensajes Estratégicos (MME).
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-165">
            {/* Benefit 1 */}
            <div className="bg-[#fdf8f0] p-8 rounded-xl border border-orange-100 hover:shadow-lg transition-shadow" data-id="element-166">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm mb-6" data-id="element-167">
                <MessageCircle className="w-6 h-6 text-[#f59e0b]" data-id="element-168" />
              </div>
              <h3 className="text-xl font-bold text-[#1a2744] mb-3 font-serif" data-id="element-169">
                Sin Confrontación
              </h3>
              <p className="text-gray-600" data-id="element-170">
                Aprenderás a "puentear" sus defensas usando su propio lenguaje
                digital. Entra en su mundo sin invadirlo.
              </p>
            </div>

            {/* Benefit 2 */}
            <div className="bg-[#fdf8f0] p-8 rounded-xl border border-orange-100 hover:shadow-lg transition-shadow" data-id="element-171">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm mb-6" data-id="element-172">
                <Clock className="w-6 h-6 text-[#f59e0b]" data-id="element-173" />
              </div>
              <h3 className="text-xl font-bold text-[#1a2744] mb-3 font-serif" data-id="element-174">
                Resultados Rápidos
              </h3>
              <p className="text-gray-600" data-id="element-175">
                En la primera semana notarás cómo baja la tensión ambiental y
                empiezan a aparecer las primeras sonrisas genuinas.
              </p>
            </div>

            {/* Benefit 3 */}
            <div className="bg-[#fdf8f0] p-8 rounded-xl border border-orange-100 hover:shadow-lg transition-shadow" data-id="element-176">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm mb-6" data-id="element-177">
                <Shield className="w-6 h-6 text-[#f59e0b]" data-id="element-178" />
              </div>
              <h3 className="text-xl font-bold text-[#1a2744] mb-3 font-serif" data-id="element-179">
                Poder Real
              </h3>
              <p className="text-gray-600" data-id="element-180">
                Recupera tu influencia como padre para poder guiarlo en los
                peligros del mundo real (drogas, redes sociales, malas
                compañías).
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section className="py-20 px-4 md:px-6 bg-[#fdf8f0] border-t border-orange-100" data-id="element-181">
        <div className="max-w-5xl mx-auto" data-id="element-182">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1a2744] text-center mb-12" data-id="element-183">
            Lo que obtendrás hoy
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-184">
            <div className="order-2 md:order-1 space-y-6" data-id="element-185">
              {/* Item 1 */}
              <div className="flex gap-4 p-4 bg-white rounded-lg shadow-sm border border-gray-100" data-id="element-186">
                <div className="mt-1 bg-[#1a2744] text-white w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 font-bold" data-id="element-187">
                  1
                </div>
                <div data-id="element-188">
                  <h3 className="text-lg font-bold text-[#1a2744] mb-1" data-id="element-189">
                    El Protocolo Central (PDF)
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-190">
                    El paso a paso exacto de los 21 días para reconstruir la
                    confianza desde cero.
                  </p>
                </div>
              </div>

              {/* Item 2 */}
              <div className="flex gap-4 p-4 bg-white rounded-lg shadow-sm border border-gray-100" data-id="element-191">
                <div className="mt-1 bg-[#1a2744] text-white w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 font-bold" data-id="element-192">
                  2
                </div>
                <div data-id="element-193">
                  <h3 className="text-lg font-bold text-[#1a2744] mb-1" data-id="element-194">
                    Scripts Listos para Copiar/Pegar
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-195">
                    Qué escribirle exactamente por WhatsApp para que se sienta
                    visto, no vigilado.
                  </p>
                </div>
              </div>

              {/* Item 3 */}
              <div className="flex gap-4 p-4 bg-white rounded-lg shadow-sm border border-gray-100" data-id="element-196">
                <div className="mt-1 bg-[#1a2744] text-white w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 font-bold" data-id="element-197">
                  3
                </div>
                <div data-id="element-198">
                  <h3 className="text-lg font-bold text-[#1a2744] mb-1" data-id="element-199">
                    Guía de Crisis
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-200">
                    Protocolo de emergencia: Qué hacer y decir cuando la puerta
                    se cierra de un portazo.
                  </p>
                </div>
              </div>
            </div>

            <div className="order-1 md:order-2 flex justify-center" data-id="element-201">
              <div className="relative" data-id="element-202">
                <div className="absolute inset-0 bg-[#f59e0b] rounded-full blur-3xl opacity-20" data-id="element-203"></div>
                <img src="https://cdn.magicpatterns.com/uploads/a14AAANKeUpFqUFkhjmY1X/heylloyd-image-1771909290386.png" alt="Pack Completo" className="relative z-10 w-full max-w-sm drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-204" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing / Offer Section */}
      <section id="offer" className="py-24 px-4 md:px-6 bg-[#1a2744] relative overflow-hidden" data-id="element-205">
        {/* Background texture */}
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
        backgroundSize: '30px 30px'
      }} data-id="element-206"></div>

        <div className="max-w-3xl mx-auto relative z-10" data-id="element-207">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden" data-id="element-208">
            <div className="bg-[#f59e0b] py-4 px-6 text-center" data-id="element-209">
              <p className="text-[#1a2744] font-bold text-sm md:text-base uppercase tracking-widest flex items-center justify-center gap-2" data-id="element-210">
                <Star className="w-4 h-4 fill-[#1a2744]" data-id="element-211" /> Oferta Especial de
                Lanzamiento <Star className="w-4 h-4 fill-[#1a2744]" data-id="element-212" />
              </p>
            </div>

            <div className="p-8 md:p-12 text-center" data-id="element-213">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1a2744] mb-4" data-id="element-214">
                Recupera a tu hijo hoy mismo
              </h2>
              <p className="text-gray-500 mb-8" data-id="element-215">
                Todo lo que necesitas para romper el silencio y volver a
                conectar.
              </p>

              {/* What's included */}
              <div className="bg-[#fdf8f0] rounded-xl p-6 mb-8 text-left space-y-3" data-id="element-216">
                {['El Protocolo Central de 21 Días (PDF)', 'Scripts Listos para Copiar/Pegar (WhatsApp)', 'Guía de Crisis: Qué hacer en los momentos más difíciles'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-217">
                    <div className="w-6 h-6 rounded-full bg-[#f59e0b] flex items-center justify-center flex-shrink-0" data-id="element-218">
                      <Check className="w-3.5 h-3.5 text-white" data-id="element-219" />
                    </div>
                    <span className="text-[#1a2744] font-medium" data-id="element-220">{item}</span>
                  </div>)}
              </div>

              <div className="flex flex-col items-center mb-8" data-id="element-221">
                <div className="flex items-center gap-2 mb-3" data-id="element-222">
                  <span className="text-gray-400 text-sm font-medium uppercase tracking-wide" data-id="element-223">
                    Precio normal:
                  </span>
                  <span className="text-gray-400 line-through text-xl" data-id="element-224">
                    $27 USD
                  </span>
                </div>
                <div className="flex items-center gap-2 mb-2" data-id="element-225">
                  <span className="text-[#f59e0b] text-sm font-bold uppercase tracking-wide" data-id="element-226">
                    Precio por lanzamiento:
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-227">
                  <span className="text-6xl font-bold text-[#1a2744] tracking-tight leading-none" data-id="element-228">
                    $6.39
                  </span>
                  <span className="text-gray-500 text-xl font-medium" data-id="element-229">USD</span>
                </div>
                <span className="bg-green-100 text-green-700 text-xs font-bold px-3 py-1 rounded-full mt-3" data-id="element-230">
                  🎉 AHORRAS 76% COMPRANDO HOY
                </span>
              </div>

              <div className="bg-orange-50 border border-orange-100 rounded-lg p-4 mb-8 text-sm text-orange-800 flex items-start gap-3 text-left" data-id="element-231">
                <AlertTriangle className="w-5 h-5 text-orange-600 flex-shrink-0 mt-0.5" data-id="element-232" />
                <p data-id="element-233">
                  <strong data-id="element-234">Piénsalo:</strong> Esto es menos de lo que cuesta una
                  pizza familiar, pero con el poder de salvar tu relación para
                  siempre.
                </p>
              </div>

              <a href="https://www.elmetodomoderno.com/cart/51416018977089:1" target="_blank" rel="noopener noreferrer" onClick={e => {
              e.preventDefault();
              handleAddToCart();
            }} className="w-full bg-[#f59e0b] hover:bg-[#d97706] text-white text-xl font-bold py-5 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 mb-6 flex items-center justify-center gap-2 group" data-id="element-235">
                SÍ, QUIERO RECUPERAR A MI HIJO AHORA
                <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-236" />
              </a>

              <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-gray-500 mb-8" data-id="element-237">
                <div className="flex items-center gap-1.5" data-id="element-238">
                  <Lock className="w-4 h-4" data-id="element-239" />
                  <span data-id="element-240">Pago 100% Seguro</span>
                </div>
                <div className="hidden md:block w-1 h-1 bg-gray-300 rounded-full" data-id="element-241"></div>
                <div className="flex items-center gap-1.5" data-id="element-242">
                  <Heart className="w-4 h-4" data-id="element-243" />
                  <span data-id="element-244">Garantía de Satisfacción</span>
                </div>
                <div className="hidden md:block w-1 h-1 bg-gray-300 rounded-full" data-id="element-245"></div>
                <div className="flex items-center gap-1.5" data-id="element-246">
                  <Check className="w-4 h-4" data-id="element-247" />
                  <span data-id="element-248">Acceso Inmediato al Email</span>
                </div>
              </div>

              {/* 30-day guarantee */}
              <div className="border-t border-gray-100 pt-8" data-id="element-249">
                <div className="flex flex-col sm:flex-row items-center gap-4 text-left" data-id="element-250">
                  <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0" data-id="element-251">
                    <RefreshCw className="w-8 h-8 text-green-600" data-id="element-252" />
                  </div>
                  <div data-id="element-253">
                    <p className="font-bold text-[#1a2744] mb-1" data-id="element-254">
                      Garantía de 30 días sin preguntas
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-255">
                      Si en 30 días no ves ningún cambio en la dinámica con tu
                      hijo, te devolvemos cada centavo. Sin preguntas, sin
                      dramas.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final Urgency Section */}
      <section className="py-20 px-4 md:px-6 bg-[#fdf8f0] border-t border-orange-100" data-id="element-256">
        <div className="max-w-3xl mx-auto text-center" data-id="element-257">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1a2744] mb-6 leading-tight" data-id="element-258">
            La pregunta no es si puedes permitirte esto.
          </h2>
          <p className="text-xl text-gray-600 mb-10 leading-relaxed" data-id="element-259">
            La pregunta es:{' '}
            <span className="text-[#dc2626] font-bold" data-id="element-260">
              ¿Puedes permitirte esperar otro año mientras la distancia crece?
            </span>
          </p>
          <button onClick={scrollToOffer} className="bg-[#1a2744] hover:bg-[#243460] text-white text-lg font-bold py-5 px-10 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 mx-auto group" data-id="element-261">
            Quiero empezar hoy{' '}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-262" />
          </button>
          <p className="mt-4 text-sm text-gray-400" data-id="element-263">
            Acceso inmediato · Garantía 30 días · $6.39 USD
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#111827] text-gray-400 py-12 px-4 md:px-6 border-t border-gray-800" data-id="element-264">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-265">
          <div className="flex items-center gap-2" data-id="element-266">
            <Shield className="w-5 h-5 text-gray-500" data-id="element-267" />
            <span className="font-serif font-bold text-gray-300" data-id="element-268">
              Vínculo Blindado
            </span>
          </div>

          <div className="text-sm text-center md:text-right" data-id="element-269">
            <div className="flex items-center justify-center md:justify-end gap-4 mb-2" data-id="element-270">
              <button onClick={() => setModal('privacy')} className="text-gray-400 hover:text-[#f59e0b] transition-colors underline underline-offset-2 text-xs" data-id="element-271">
                Política de Privacidad
              </button>
              <span className="text-gray-700" data-id="element-272">·</span>
              <button onClick={() => setModal('terms')} className="text-gray-400 hover:text-[#f59e0b] transition-colors underline underline-offset-2 text-xs" data-id="element-273">
                Términos y Condiciones
              </button>
            </div>
            <p data-id="element-274">
              &copy; {new Date().getFullYear()} Vínculo Blindado. Todos los
              derechos reservados.
            </p>
            <p className="mt-2 text-xs text-gray-600" data-id="element-275">
              Este sitio no es parte del sitio web de Facebook o Facebook Inc.
              Además, este sitio no está respaldado por Facebook de ninguna
              manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}